import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
  {
    q: "How do I book freight from Turkey?",
    a: "Submit a booking request inside the DeMaxtore Workspace through FreightIQ™. Our platform coordinates directly with carriers to confirm space, allocate containers and generate the booking confirmation — without you switching between portals or chasing emails.",
  },
  {
    q: "Can I book FCL shipments?",
    a: "Yes. FreightIQ™ supports Full Container Load bookings across 20GP, 40GP, 40HQ and reefer equipment with multiple shipping lines. LCL coordination is available on request inside your Workspace.",
  },
  {
    q: "Which shipping lines are supported?",
    a: "FreightIQ™ coordinates with major global carriers including MSC, Maersk, CMA CGM, Hapag-Lloyd, ONE, Evergreen and ZIM — plus regional partners serving Turkey-origin lanes.",
  },
  {
    q: "Can I track my shipment?",
    a: "Yes. Live Shipment Tracking™ provides real-time milestones from booking confirmation, container pick-up, port gate-in, loading, vessel departure, all the way to final delivery — all inside your Workspace.",
  },
  {
    q: "Can I manage multiple bookings?",
    a: "Absolutely. The Workspace centralises every booking, document and milestone across unlimited shipments, teams and brands. Roles and permissions are built in.",
  },
  {
    q: "Is FreightIQ™ included inside DeMaxtore Workspace?",
    a: "Yes. FreightIQ™ is a native module inside the DeMaxtore Workspace alongside Purchase Order, Inspection™ and Live Shipment Tracking™. One login. One operating system.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-xs tracking-[0.18em] uppercase font-bold text-[#3B82F6]">
            FAQ
          </div>
          <h2 className="mt-3 font-display font-extrabold text-4xl md:text-5xl tracking-[-0.02em] text-[#0B1F3A]">
            Frequently asked questions.
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Everything importers ask about booking freight from Turkey through
            DeMaxtore.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12 rounded-2xl bg-white border border-slate-200 overflow-hidden"
          data-testid="faq-accordion"
        >
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-slate-100 last:border-b-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="px-6 py-5 text-left font-display font-bold text-[#0B1F3A] text-base md:text-lg hover:no-underline hover:bg-slate-50/60 tracking-tight"
              >
                <span className="flex items-center gap-4">
                  <span className="font-mono text-xs text-slate-400">
                    0{i + 1}
                  </span>
                  <span>{item.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="px-6 pb-5 pl-[3.75rem] text-[15px] leading-relaxed text-slate-600"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
